import { takeLatest, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { resolveError } from 'utils/resolveError';
import api from 'api/client';
import * as validation from 'reducer/rValidation';
import * as message from 'reducer/rMessageBox';

/**
 * 파일 검증.
 *
 * 파일을 그대로 올린다. 포탈도 발급 서버로 그대로 넘긴다 — 형식 해석(서명 검증·AES 복호화)은
 * 발급 서버가 소유한다. 화면이나 포탈이 흉내 내면 규칙이 여러 곳에 생긴다.
 */
export function* sValidation() {
    yield takeLatest(validation.validateRequest, validate);
}

function* validate(action) {
    try {
        const { file } = action.payload;

        const form = new FormData();
        form.append('file', file);

        // Content-Type 을 직접 넣지 않는다. multipart 경계 문자열은 브라우저가 만든다 —
        // 손으로 넣으면 경계가 빠져 서버가 파트를 찾지 못한다.
        const response = yield call(() => api.post('/licenses/validate', form));

        if (response.data.resultCode === '0000') {
            yield put(validation.validateSuccess(response.data.data));
        } else {
            const msg = resolveError(response.data)
                || i18next.t('common.unexpectedError');
            yield put(validation.validateFailure(msg));
            yield put(message.fetchErrorMessageBoxRequest(msg));
        }
    } catch (error) {
        const msg = error.response?.status === 401
            ? i18next.t('common.sessionExpired')
            : i18next.t('common.unexpectedError');
        yield put(validation.validateFailure(msg));
        yield put(message.fetchErrorMessageBoxRequest(msg));
    }
}
